import { useEffect, useState } from "react";
import { HeaderTabs } from "../components";
import { setPageTitle } from "../helper/metaDataHelper";
import BalanceCard from "./components/BalanceCard";
import YourAccounts from "./components/YourAccounts";
import PricesCard from "./components/PricesCard";
import RecentTransactions from "./components/RecentTransactions";
import NewsTicker from "./components/NewsTicker";
import MarketPricesTable from "./components/MarketPricesTable";
import MobileBottomNav from "./components/MobileBottomNav";
import { useDispatch, useSelector } from "react-redux";
import { getModuleStatus } from "../redux/actions/lookups/getModuleStatus";
import { useNavigate } from "react-router-dom";
import { useRecentTransaction } from "../hooks/useRecentTransaction";
import { RecentTransactionListSkeleton } from "../components/Skeleton/TransactionHistorySkeleton";
import MarketPricesSkeleton from "../components/Skeleton/MarketPricesSkeleton";
import MarketPricesTableSkeleton from "../components/Skeleton/MarketPricesTableSkeleton";
import AccountListSkeleton from "../components/Skeleton/AccountListSkeleton";
import MarketStats from "./components/MarketStats";
import { getCoingeckoMarketsPrices } from "../redux/actions/Coingecko/dashboard";
import { getClientAccounts } from "../redux/actions/home/ClientInfoAction";

const NewCryptoPage = () => {
  const [proView, setProView] = useState(false);
  const [marketSummary, setMarketSummary] = useState([]);
  const [marketPrices, setMarketPrices] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadData, setLoadData] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const { client_id } = useSelector((state) => state.userInfo.userInfo);
  const cryptoAccounts = useSelector((state) => state.client.clientInfo.crypto_accounts) ?? [];
  const [recentTransactionsLoading, setRecentTransactionsLoading] = useState(false);
  const { lastThreeTransactions: recentTransactions } = useRecentTransaction(setRecentTransactionsLoading, "crypto", 6, loadData);

  useEffect(() => {
    setPageTitle("Crypto");
  }, []);

  useEffect(() => {
    const getCryptoData = async () => {
      try {
        if (!user) {
          navigate("/signin");
        } else {
          setIsLoading(true);
          
          // Run all the async actions concurrently
          const [dashboard] = await Promise.all([
            dispatch(getCoingeckoMarketsPrices()),
            dispatch(getClientAccounts()),
            dispatch(getModuleStatus({ modules: ["Bitpace", "Crypto", "Fireblocks"] })),
          ]);
          
          setMarketSummary(dashboard?.data?.market_summary);
          setMarketPrices(dashboard?.data?.market_prices)
        }
      } catch (error) {
        console.error("Error in useEffect:", error);
      } finally {
        setIsLoading(false);
      }
    };

    getCryptoData();
  }, [user, dispatch, navigate, loadData, client_id]);

  return (
    <main className="font-outfit">
      <div className="mx-auto min-h-screen max-w-[1024px] px-4 pb-[calc(5.5rem+env(safe-area-inset-bottom))] sm:pb-0">
        <div className="flex flex-col space-y-4">
          <div className="hidden sm:block">
            <HeaderTabs />
          </div>
          
          <BalanceCard 
            proView={proView} 
            onProViewChange={setProView} 
            loading={isLoading}
            setLoadData={setLoadData}
          />

          {proView ? (
            <>
              <NewsTicker marketPrices={marketPrices} />

              <div className="grid grid-cols-1 lg:grid-cols-[1.19fr_1fr] items-start gap-3">                
                {isLoading ? <AccountListSkeleton /> : <YourAccounts className="h-[371px]" />}
                <RecentTransactions 
                  isLoading={recentTransactionsLoading}
                  className="h-[371px]" 
                  recentTransactions={recentTransactions} 
                />
              </div>

             {/* {isLoading ? <MarketPricesTableSkeleton /> : <MarketStats marketSummary={marketSummary} />} */}
             {(!isLoading && marketPrices) && <MarketStats market_summary={marketSummary} />}
             {isLoading ? <MarketPricesTableSkeleton /> : <MarketPricesTable marketPricesData={marketPrices} cryptoAccounts={cryptoAccounts} />}

            </>
          ) : (
            <div className="grid grid-cols-1 lg:grid-cols-12 items-start gap-4">
              <div className="flex flex-col gap-4 lg:col-span-8">
                {isLoading ? <AccountListSkeleton /> : <YourAccounts />}

                {isLoading ? 
                  <RecentTransactionListSkeleton />
                  :
                  <RecentTransactions 
                    isLoading={recentTransactionsLoading || isLoading}
                    recentTransactions={recentTransactions} 
                  />
                }

              </div>
              <div className="lg:col-span-4">
                {isLoading ? <MarketPricesSkeleton /> : <PricesCard data={marketPrices} />}
              </div>
            </div>
          )}
        </div>
      </div>

      <MobileBottomNav />
    </main>
  );
};

export default NewCryptoPage;
